module.exports = __webpack_public_path__ + "static/img_1442-efce44c91666e401cc779c9d02cba77e.webp";